const StatCard = ({ label, value, accent = "#38BDF8" }) => (
  // min-w-0 lets the grid track shrink below the label's intrinsic width on narrow phones.
  <div className="min-w-0 rounded-lg bg-white/[0.06] p-2.5 sm:p-3">
    <p className="truncate text-[9px] uppercase tracking-wider text-white/60">{label}</p>
    <p className="mt-1 truncate text-base font-black sm:text-lg" style={{ color: accent }}>{value}</p>
  </div>
);

const Bar = ({ height, accent }) => (
  <div className="w-full rounded-sm origin-bottom animate-bar-grow" style={{ height, background: accent }} />
);

const DeviceMockup = ({ className = "" }) => (
  <div className={`relative ${className}`} data-testid="eduanant-device-mockup">
    <div className="absolute -inset-4 rounded-full bg-sky-400/10 blur-3xl sm:-inset-10" aria-hidden="true" />
    <div className="relative rounded-[2rem] border border-white/15 bg-[#0b0f14] p-2.5 shadow-[0_40px_80px_-30px_rgba(0,0,0,0.9)]">
      <div className="overflow-hidden rounded-[1.6rem] bg-[#0e141b]">
        <div className="flex items-center justify-between border-b border-white/5 px-5 py-3">
          <div className="flex items-center gap-2">
            <span className="h-2.5 w-2.5 rounded-full bg-sky-400" />
            <span className="text-xs font-bold tracking-tight text-white">EduAnant</span>
          </div>
          <span className="rounded-full bg-sky-400/10 px-2.5 py-1 text-[9px] font-bold uppercase tracking-wider text-sky-300">
            Live · Term 2
          </span>
        </div>
        <div className="grid grid-cols-3 gap-2 p-3 sm:gap-2.5 sm:p-4">
          <StatCard label="Students" value="1,240" />
          <StatCard label="Attendance" value="96.2%" accent="#4ADE80" />
          <StatCard label="Fees due" value="₹1.8L" accent="#F59E0B" />
        </div>
        <div className="mx-4 rounded-lg bg-white/[0.04] p-4">
          <div className="flex items-center justify-between">
            <p className="text-[10px] font-bold uppercase tracking-wider text-white/50">Fee collection</p>
            <p className="text-[10px] text-sky-300">This term</p>
          </div>
          <div className="mt-3 flex h-20 items-end gap-1.5">
            {["35%", "55%", "45%", "70%", "62%", "88%", "78%", "95%"].map((h, i) => (
              <Bar key={i} height={h} accent={i === 7 ? "#38BDF8" : "rgba(56,189,248,0.25)"} />
            ))}
          </div>
        </div>
        <div className="space-y-2 p-4">
          {[
            ["Admissions open — Class XI", "38 new applications"],
            ["PTM scheduled — Saturday", "214 parents confirmed"],
            ["Fee reminders sent", "Defaulter list updated"],
          ].map(([title, sub]) => (
            <div key={title} className="flex items-center justify-between rounded-lg bg-white/[0.04] px-3.5 py-2.5">
              <div>
                <p className="text-[11px] font-bold text-white/80">{title}</p>
                <p className="text-[9px] text-white/55">{sub}</p>
              </div>
              <span className="h-1.5 w-1.5 rounded-full bg-sky-400" />
            </div>
          ))}
        </div>
      </div>
    </div>
    <p className="mt-4 text-center text-[10px] uppercase tracking-[0.2em] text-white/30">
      Illustrative interface — real product at eduanant.cloud
    </p>
  </div>
);

export default DeviceMockup;
